var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loaded)?_c('Tabs',{attrs:{"data":{ form: _vm.form, model: _vm.model }}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }